import type { HiringStage } from "@/features/hr/hiring/types/stages";
import type { SigningStatus } from "@/shared/types";
import { JOB_APP_REVIEW } from "@/features/hr/contracts/consts";

export interface JobApplicationActionsConfig {
  showDownloadButton: boolean;
  showUploadButton: boolean;
  showReviewButtons: boolean;
  showSignButton: boolean;
  showCancelSigningButton: boolean;
}

export function getJobApplicationActions(
  stage: HiringStage,
  signingStatus?: SigningStatus | null,
): JobApplicationActionsConfig {
  const orgAlreadySigned = signingStatus !== null && signingStatus !== undefined && signingStatus >= 1;

  if (stage === JOB_APP_REVIEW) {
    return {
      showDownloadButton: false,
      showUploadButton: false,
      showReviewButtons: false,
      showSignButton: false,
      showCancelSigningButton: false,
    };
  }

  return {
    showDownloadButton: !orgAlreadySigned,
    showUploadButton: false,
    showReviewButtons: false,
    showSignButton: !orgAlreadySigned,
    showCancelSigningButton: signingStatus === 0,
  };
}
